module.exports = __webpack_public_path__ + "img/20250927.a5f3b562.png";